<!-- [class.bg]="navbarScroll" -->

<nav class="bg" [class.hidden]="!navbarVisible && !menuSliderLeft">
  <div class="container-fluid">
    <div class="left" [class.text-white]="menuSliderLeft">
      <a (click)="$event.preventDefault()" class="logo">
        <svg viewBox="0 0 127 122" fill="none">
          <path
            d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z" />
          <path
            d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z" />
          <path
            d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z" />
          <path
            d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z" />
          <path
            d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z" />
        </svg>
        <div class="logo--content">
          <!-- <div class="logo--content__beta">BETA</div> -->
          <div class="logo--content__title">{{ shopProfile.shop_name }}</div>
          <!-- <div class="logo--content__desc">{{ sloganText }}</div> -->
        </div>
      </a>
    </div>
    <ul class="icons">
      <ng-container *ngIf="isUserLogin === 0; else loggedIn">
        <!-- <li>
          
          <i class="fa-solid fa-sign-in-alt" id="loginBtn" (click)="openSigninModal()"></i>
        </li> -->
        <li class="d-flex justify-content-center align-items-center" style="cursor: pointer;"
          (click)="openSigninModal()">
          <!-- <i class="fa-solid fa-sign-in-alt" id="loginBtn" ></i>  -->
          <span style="color: white;font-size: 1.2rem;" class="ml-2">Login</span>
        </li>
      </ng-container>
      <ng-template #loggedIn>
        <li>
          <i class="fa-solid fa-user" (click)="goToProfile()"></i>
        </li>
        <li>
          <i class="fa-solid fa-right-from-bracket" (click)="openShopSignoutPopup(shopSignoutPopup)"></i>
        </li>
      </ng-template>
    </ul>
  </div>
</nav>
<div class="nav-top-mobile" [class.hidden]="!navbarVisible && !menuSliderLeft">
  <div class="left">
    <div class="logo">
      <div class="logo--content">
        <!-- <div class="logo--content__beta">BETA</div> -->
        <div class="logo--content__title" *ngIf="shopProfile.shop_name != 'null'">
          <span class="d-md-block d-none">{{ shopProfile.shop_name }}</span>
          <span class="d-md-none d-block">{{ shopProfile.shop_name?.toString().substr(0,20) }}</span>
        </div>
      </div>
    </div>
  </div>
  <ul class="">
    <ng-container *ngIf="isUserLogin === 0; else loggedIn">
      <!-- <li>
        <i class="fa-solid fa-sign-in-alt" id="loginBtn" (click)="openSigninModal()"></i>
      </li> -->
      <li class="d-flex justify-content-center align-items-center" style="cursor: pointer;" (click)="openSigninModal()">
        <!-- <i class="fa-solid fa-sign-in-alt" id="loginBtn" ></i>  -->
        <span style="color: white;font-size: 1.2rem;" class="ml-2">Login</span>
      </li>
    </ng-container>
    <ng-template #loggedIn>
      <li>
        <i class="fa-solid fa-user" (click)="goToProfile()"></i>
      </li>
      <li>
        <i class="fa-solid fa-right-from-bracket" (click)="openShopSignoutPopup(shopSignoutPopup)"></i>
      </li>
    </ng-template>
  </ul>
</div>
<div class="main mb-0">
  <router-outlet></router-outlet>
</div>

<div class="message-popup" *ngIf="showMessagePopup" [class.active]="showMessagePopup"
  [style.right]="messagePopupPos.right" [style.bottom]="messagePopupPos.bottom" (click)="showMessagePopup=false">
  
  <div class="message-popup__body">
    <!-- <div class="name">{{ messageData?.title }}</div> -->
    <div class="desc">{{ messageData?.description }}</div>
  </div>
  <div class="close-btn">
    <span style="text-align: justify;">
      <i class="fa-solid fa-xmark" (click)="showMessagePopup = false"></i>
    </span>

  </div>

</div>



<ng-template #shopSignoutPopup let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="">
            <h2 class="cart_title mb-2">Are you sure ?</h2>
            <p class="text-center">You want to logout from the website.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="cart_btn mt-4">
            <a (click)="shopLogout()" class="confirm_button">Yes </a>
            <a (click)="modalDismissAll()" class="confirm_button">No </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-sign-in #SignIn [withoutSteps]="true"></app-sign-in>